module.exports = __webpack_public_path__ + "static/sample-projects-14-590ea1f5ebcfbbf41838ac6af25c09b2.png";